module.exports = __webpack_public_path__ + "static/media/01.00ef2c54.jpg";